import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import Loading from "../Loading";
import RolesCheckboxes from "../RolesCheckboxes";
import { getRolesOfUser, normalizeRoles } from "../../utils/roles";

function EditUserRoles({ user, setShowModal, onSaved }) {
  const [roles, setRoles] = useState(getRolesOfUser(user));
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const saveRoles = async (e) => {
    e.preventDefault();
    const selected = normalizeRoles(roles);
    if (selected.length === 0) {
      setError("Please select at least one role");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      try {
        await axios.post(
          `${"https://api.sedihisham.com"}/users/changeroles/${user.id}`,
          { roles: selected }
        );
      } catch (err) {
        // server not updated yet: it only knows the single-role endpoint
        if (err.response?.status === 404 && selected.length === 1) {
          await axios.get(
            `${"https://api.sedihisham.com"}/users/changerole/${user.id}/${selected[0]}`
          );
        } else {
          throw err;
        }
      }
      setLoading(false);
      onSaved(user.id, selected);
      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Your changes had been saved",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
      setError(
        err.response?.data?.message ||
          "Could not save the roles, please try again."
      );
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6 w-[85%] max-w-[1000px]">
          <form onSubmit={saveRoles}>
            <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex justify-between h-[50px] rounded-t">
                <div className="text-[18px] w-[30%] text-center m-auto font-semibold">
                  Edit User Roles
                </div>
                <div className="w-[70%] rounded-bl-xl rounded-tr-xl bg-[#E9F6FD] h-full"></div>
              </div>
              <div className="relative p-6 w-full">
                <p className="text-[14px] font-[400] mb-4">
                  {user.email} — select one or more roles. The user gets the
                  permissions of every selected role; an open dashboard picks
                  them up within a minute, no need to sign in again.
                </p>
                <RolesCheckboxes selected={roles} onChange={setRoles} />
              </div>
              {error ? (
                <p className="text-[14px] ml-6 font-[400] text-[red]">
                  <FontAwesomeIcon icon={faCircleExclamation} /> {error}
                </p>
              ) : null}
              <div className="flex items-center justify-end p-3 rounded-b">
                <div className="flex pb-[10px]">
                  <div
                    onClick={() => setShowModal(false)}
                    className="rounded-full cursor-pointer text-[13px] mr-2 px-6 py-1 text-[#0388CC] bg-[#E9F6FD]"
                  >
                    Cancel
                  </div>
                  <input
                    type="submit"
                    className="cursor-pointer rounded-full text-[13px] px-6 py-1 text-[#fff] bg-[#0388CC]"
                    value="Save"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {loading ? <Loading /> : null}
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}

export default EditUserRoles;
